var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_vm._v(" 版权所有：北京联合信任技术服务有限公司 京ICP备13046264号-2 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }